import { Container, Row, Col, Carousel } from "react-bootstrap";

import sliderDesktop from "../../assets/img/strada_desktop.png";
import sliderMobile from "../../assets/img/strada_mobile.png";

const Slider = () => {
  return (
    <Container fluid className="p-0 m-0">
      <Row className="p-0 m-0">
        <Col md={12} className="mx-auto p-0 m-0">
          <div className="d-md-block d-none">
            <Carousel controls={false} indicators={false}>
              <Carousel.Item key={1}>
                <a href={"#formulario"} target="_self" rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderDesktop} alt="Montironi" />
                </a>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              <Carousel.Item key={1} controls={false} indicators={false}>
                <a href={"#formulario"} target="_self" rel="noreferrer">
                  <img className="d-block w-100 img-fluid" src={sliderMobile} alt="Montironi" />
                </a>
              </Carousel.Item>
            </Carousel>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Slider;
